import * as Preact from 'preact';
import * as IconButton from '../A_IconButton';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { SxProps } from '@mui/system';

export interface Props {
    onBackClick?: () => void;
    title?: string;
    onCloseClick: () => void;
    sx?: SxProps;
}

export const Component = (props: Props) => {
    return (
        <Box
            sx={{
                height: '64px',
                width: '100%',
                padding: '16px',
                boxSizing: 'border-box',
                display: 'grid',
                gridTemplateAreas: "'back title close'",
                gridTemplateColumns: '32px auto 32px',
                alignItems: 'center',
                background: 'white',
                borderBottom: '1px solid rgba(0, 0, 0, .15)',
                ...props.sx,
            }}
        >
            {props.onBackClick && (
                <IconButton.Component
                    color="secondary"
                    size="small"
                    onClick={props.onBackClick}
                    sx={{ gridArea: 'back' }}
                >
                    <ArrowBackIcon />
                </IconButton.Component>
            )}
            {props.title && (
                <Typography textAlign="center" variant="h6" sx={{ gridArea: 'title' }}>
                    {props.title}
                </Typography>
            )}
            <IconButton.Component
                color="secondary"
                size="small"
                onClick={props.onCloseClick}
                sx={{ gridArea: 'close' }}
            >
                <CloseIcon />
            </IconButton.Component>
        </Box>
    );
};

Component.displayName = 'ModalTitle';
